{
    "Profile_Policy_Servicing.servicingStats": "Servicing Stats",
    "Profile_Policy_Servicing.participantDetails": "Particpant Details",
    "Profile_Policy_Servicing.insurer": "Insurer",
    "Profile_Policy_Servicing.previousInsurer": "Previous Insurer",
    "Profile_Policy_Servicing.broker": "Broker",
    "Profile_Policy_Servicing.partner": "Partner",
    "Profile_Policy_Servicing.epicLookupCode": "Epic Lookup Code"
}
